import { jsx as _jsx } from "react/jsx-runtime";
import get from 'lodash/get';
import React from 'react';
import Account from 'modules/Account';
import { LogoLayout } from 'modules/Layout';
import SessionStorage from 'libs/SessionStorage';
import OidcService from 'services/OidcService';
async function action({ route, store, query, getUrl }, params) {
    const { invitationCountryCode, invitationToken } = params;
    const defaultRedirectRouteName = 'sign-up';
    let redirect = null;
    if (process.env.BROWSER) {
        const user = await OidcService.getUser();
        let redirectRouteName = defaultRedirectRouteName;
        SessionStorage.setItem('invitationCountryCode', invitationCountryCode);
        SessionStorage.setItem('invitationToken', invitationToken);
        try {
            const { invitation } = await store.dispatch(Account.actions.setInvitation());
            if (user && invitation) {
                redirectRouteName = 'invitation';
            } else {
                redirectRouteName = get(query, 'redirect') || defaultRedirectRouteName;
            }
        } catch (err) {
        // handle in saga
        }
        try {
            redirect = getUrl(redirectRouteName);
        } catch (err) {
            redirect = getUrl(defaultRedirectRouteName);
        }
    }
    return {
        chunks: [
            'account'
        ],
        name: route.name,
        redirect,
        component: /*#__PURE__*/ _jsx(LogoLayout, {})
    };
}
export default action;
